<template>
    <div>
        <el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
            <el-form :inline="true">
                <el-form-item>
                    <el-input v-model="SearchName" placeholder="请输入角色名" prefix-icon="el-icon-search"
                              size="small"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="Find" icon="el-icon-search">查询</el-button>
                </el-form-item>
                <el-form-item v-if="Limits.role_create">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="AddCharacter">添加角色</el-button>
                </el-form-item>
                <el-form-item style="float: right;">
                    <el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <el-table :data="List" border v-loading="listloading" style="width: 99.9%" :max-height="maxHeight">
            <el-table-column prop="name" label="角色"></el-table-column>
            <!--<el-table-column prop="permissions" label="权限"></el-table-column>-->
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button v-if="Limits.role_view" type="primary" size="mini" style="padding: 7px;"
                               @click="look(scope.$index,scope.row)">查看权限
                    </el-button>
                    <el-button v-if="Limits.role_update" type="primary" size="mini" style="padding: 7px;"
                               @click="change(scope.$index,scope.row)">修改权限
                    </el-button>
                    <el-button v-if="Limits.role_delete" type="danger" size="mini" style="padding: 7px;"
                               @click="Delete(scope.$index,scope.row)">删除角色
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-col :span="24" class="toolbar downtool">
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="Pagesize"
                           :current-page="Curpage" :total="total" style="float:right;">
            </el-pagination>
        </el-col>

        <!--创建新角色-->
        <el-dialog :fullscreen="true" title="创建新角色" :visible.sync="AddVisible" append-to-body center>
            <el-form :model="form">
                <el-form-item label="角色名：" :label-width="formLabelWidth">
                    <el-input placeholder="请填写角色名称(必填)" v-model="form.CharacterName" auto-complete="off"></el-input>
                </el-form-item>

                <el-form-item v-for="item in roledata.permissions" :key="item.group" :label="item.group"
                              :label-width="formLabelWidth">
                    <el-checkbox-group v-model="form.role">
                        <el-checkbox v-for="it in item.items" :key="it.value" :label="it.value">{{it.label}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <!--<el-tabs v-model="tabActiveName" @tab-click="" type="border-card" tab-position="top">-->
                    <!--<el-tab-pane v-for="(item,index) in roledata.permissions" :key="item.group" :label="item.group" :name="index">-->
                        <!--<el-checkbox-group v-model="form.role">-->
                            <!--<el-checkbox v-for="it in item.items" :key="it.value" :label="it.value">{{it.label}}-->
                            <!--</el-checkbox>-->
                        <!--</el-checkbox-group>-->
                    <!--</el-tab-pane>-->
                <!--</el-tabs>-->

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" type="primary" @click="UpCharacter" :loading="createloading"
                           style="padding: 10px 50px;">提 交
                </el-button>
            </div>
        </el-dialog>

        <!--查看权限-->
        <el-dialog :fullscreen="true" title="权限详细" :visible.sync="LookVisible" append-to-body center>
            <el-form :model="form2">
                <el-form-item label="角色名：" :label-width="formLabelWidth">
                    <el-input placeholder="请填写角色名称(必填)" :disabled="true" v-model="form2.CharacterName"
                              auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item v-for="item in roledata.permissions" :key="item.group" :label="item.group"
                              :label-width="formLabelWidth">
                    <el-checkbox-group v-model="form2.role" id="box">
                        <el-checkbox v-for="it in item.items" :key="it.value" :label="it.value">{{it.label}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
        </el-dialog>

        <!--修改权限-->
        <el-dialog :fullscreen="true" title="修改角色权限" :visible.sync="ChangeVisible" append-to-body center>
            <el-form :model="form3">
                <el-form-item label="角色名：" :label-width="formLabelWidth">
                    <el-input placeholder="请填写角色名称(必填)" v-model="form3.CharacterName" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item v-for="item in roledata.permissions" :key="item.group" :label="item.group"
                              :label-width="formLabelWidth">
                    <el-checkbox-group v-model="form3.role">
                        <el-checkbox v-for="it in item.items" :key="it.value" :label="it.value">{{it.label}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" type="primary" @click="ChangeCharacter" style="padding: 10px 50px;"
                           :loading="changeloading">确 认 修 改
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {GetRoleslist, GetPermissionslist} from "../api/api"

    export default {
        data() {
            return {
                token: "",
                Limits: "",
                List: [],
                listloading: false,
                total: 1,
                Curpage: 1,
                Pagesize: 20,
                AddVisible: false,
                LookVisible: false,
                ChangeVisible: false,
                changeloading: false,
                createloading: false,
                formLabelWidth: "110px",
                SearchName: "",
                form: {
                    CharacterName: "",
                    role: []
                },
                form2: {
                    CharacterName: "",
                    role: []
                },
                form3: {
                    CharacterName: "",
                    role: []
                },
                roledata: [],
                Form: {
                    name: "",
                    permissions: []
                },
                maxHeight: 600
            }
        },
        methods: {
            handleCurrentChange(val) {
                this.Curpage = val
                if (this.SearchName) {
                    this.GetList(GetRoleslist, {
                        page: this.Curpage,
                        token: this.token,
                        q: JSON.stringify([{"AND": {"name": '~' + this.SearchName}}])
                    })
                } else {
                    this.GetList(GetRoleslist, {page: this.Curpage, token: this.token})
                }
            },
            Getrole() {
                GetPermissionslist({token: this.token}).then(res => {
                    console.log("res", res.data)
                    this.roledata = res.data.items
                }).catch(err => {
                    console.log(err)
                })
            },
//			打开添加角色页面
            AddCharacter() {
                this.AddVisible = true
            },
//			新建角色
            UpCharacter() {
                if (this.form.CharacterName) {
                    let url = "/roles?token=" + this.token
                    this.createloading = true
                    this.axios.post(url, {"name": this.form.CharacterName, "permissions": this.form.role}).then(res => {
                        if (res.status == "200") {
                            this.$message({
                                type: 'success',
                                message: '操作成功!'
                            });
                            this.form.CharacterName = ""
                            this.form.role = []
                            this.createloading = false
                            this.AddVisible = false
                            this.GetList(GetRoleslist, {page: this.Curpage, token: this.token})
                        } else {
                            this.$message.error('对不起，请求失败。')
                            this.createloading = false
                        }
                    }).catch(err => {
                        this.$message.error(err.response.data.message)
                        this.createloading = false
                    })
                } else {
                    this.$message.error("请填写用户名！！！")
                }
            },
//			修改角色
            ChangeCharacter() {
                if (this.form3.CharacterName) {
                    this.changeloading = true
                    let ur = "/roles/" + this.Form.name + "?token=" + this.token
                    this.axios.put(ur, {"name": this.form3.CharacterName, "permissions": this.form3.role}).then(res => {
                        if (res.status == "200") {
                            this.$message({
                                type: 'success',
                                message: '操作成功!'
                            });
                            this.changeloading = false
                            this.ChangeVisible = false
                            this.GetList(GetRoleslist, {page: this.Curpage, token: this.token})
                        } else {
                            this.$message.error('对不起，请求失败。')
                            this.changeloading = false
                        }
                    }).catch(err => {
                        this.$message.error(err.response.data.message)
                        this.changeloading = false
                    })
                } else {
                    this.$message.error("请填写用户名！！！")
                }
            },
//			打开查看权限页面
            look(index, row) {
                this.LookVisible = true
                this.Form = Object.assign({}, row);
                this.form2.CharacterName = this.Form.name
                this.form2.role = this.Form.permissions
            },
//			打开修改权限页面
            change(index, row) {
                this.ChangeVisible = true
                this.Form = Object.assign({}, row);
                this.form3.CharacterName = this.Form.name
                this.form3.role = this.Form.permissions
            },
//			删除角色
            Delete(index, row) {
                this.$confirm('确认删除该角色?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.listloading = true
                    this.Form = Object.assign({}, row);
                    let url = "/roles/" + this.Form.name + "?token=" + this.token
                    this.axios.delete(url).then(res => {
                        if (res.status == "204") {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.GetList(GetRoleslist, {page: this.Curpage, token: this.token})
                        } else {
                            this.$message.error('对不起，请求失败。')
                            this.listloading = false
                        }
                    }).catch(err => {
                        this.$message.error(err.response.data.message)
                        this.listloading = false
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                })

            },
            Find() {
                if (this.SearchName) {
                    this.GetList(GetRoleslist, {
                        page: this.Curpage,
                        token: this.token,
                        q: JSON.stringify([{"AND": {"name": '~' + this.SearchName}}])
                    })
                }
            },
            Refresh() {
                this.SearchName = ""
                this.Curpage = 1
                this.GetList(GetRoleslist, {page: this.Curpage, token: this.token})
            },


        },
        created() {
            this.token = sessionStorage.getItem("BBRtoken");
            this.Limits = JSON.parse(sessionStorage.getItem("limits"))
            this.GetList(GetRoleslist, {page: this.Curpage, token: this.token})
            this.Getrole()
        },
        mounted() {
            this.$nextTick(function () {
                this.Gethigh()
            })
        }
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// RoleManage.vue?5fecd267